import { PermissionScope, type PermissionScopeEnum } from "@fitness-app/data-models";

export const scopeLabels: Record<PermissionScopeEnum, string> = {
  [PermissionScope.NONE]: "Brak",
  [PermissionScope.ASSIGNED]: "Przypisani",
  [PermissionScope.TEAM]: "Zespół",
  [PermissionScope.ALL]: "Całe konto",
};

// public.permission.description is seeded in English — it is catalog data, not UI
// copy. The panel is Polish, so label the keys here and fall back to the catalog
// description for a key added after this map.
export const permissionLabels: Record<string, string> = {
  "agents.use": "Dostęp do wewnętrznego AI",
  "appConfig.manage": "Zarządzanie konfiguracją aplikacji",
  "automation.manage": "Zarządzanie automatyzacjami",
  "campaigns.manage": "Zarządzanie kampaniami do klientek",
  "chat.alerts.read": "Kolejka zastrzeżeń klientów do weryfikacji",
  "chat.read": "Podgląd rozmów z klientkami",
  "chat.write": "Wysyłanie wiadomości i zmiany w rozmowach",
  "clients.read": "Podgląd klientek",
  "clients.write": "Dodawanie i edycja klientek",
  "engagement.badges.manage": "Zarządzanie odznakami",
  "engagement.manage": "Zarządzanie wyzwaniami i nawykami",
  "helpCenter.manage": "Redakcja centrum pomocy dla klientek",
  "helpCenter.publish": "Publikowanie materiałów centrum pomocy",
  "landings.manage": "Zarządzanie landing page'ami",
  "marketing.read": "Podgląd analityki marketingowej",
  "nutrition.ingredients.approve": "Zatwierdzanie składników",
  "nutrition.ingredients.manage": "Edycja składników w katalogu",
  "nutrition.manage": "Zarządzanie planami żywieniowymi",
  "products.manage": "Zarządzanie produktami i sprzedażą",
  "products.read": "Podgląd katalogu produktów (nazwy)",
  "products.resources.read": "Podgląd materiałów produktowych",
  "products.resources.write": "Edycja materiałów produktowych",
  "programs.manage": "Zarządzanie planami treningowymi",
  "sales.analytics.read": "Analityka sprzedaży dla agenta AI (przychód, kohorty)",
  "sales.checkout.manage": "Zarządzanie koszykami sprzedażowymi i kodami zniżkowymi",
  "sales.manage": "Zarządzanie danymi sprzedażowymi (CRM)",
  "sales.read": "Podgląd danych sprzedażowych (CRM)",
  "sales.settlements.read": "Podgląd rozliczeń sprzedaży",
  "support.manage": "Zarządzanie zgłoszeniami wsparcia",
  "support.read": "Podgląd zgłoszeń wsparcia",
  "support.resources.manage": "Zarządzanie materiałami agenta wsparcia",
  "surveys.manage": "Zarządzanie ankietami klientek",
  "team.chatMetrics.read": "Podgląd metryk odpowiedzi na czacie",
  "team.manage": "Zarządzanie członkami zespołu",
  "team.permissions.manage": "Zarządzanie uprawnieniami",
  "team.read": "Podgląd zespołu",
  "team.stats.read": "Podgląd statystyk i rozliczeń zespołu",
};
